import {
  slackService
} from "../services/api";
import {
  OAuthCallbackPage
} from "./pairing/OAuthCallbackPage";

export function SlackCallbackPage() {
  return (
    <OAuthCallbackPage
      providerName="Slack"
      successType="SLACK_OAUTH_SUCCESS"
      errorType="SLACK_OAUTH_ERROR"
      spinnerColorClass="border-indigo-600"
      handleCallback={slackService.handleCallback}
      showSuccessScreen={false}
      popupSuccessCloseDelayMs={1000}
      navigateDelayOnSuccessMs={0}
      supportsDetachedPopup
    />
  );
}
